import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { formatTimeDate } from '@/utils/functions/formatTimeDate';

import LetterTemplatesItemMenu from '@/views/pages/Templates/elements/LetterTemplatesItemMenu';

import styles from '@/views/pages/Templates/elements/LetterTemplateCard.module.scss';

const LetterTemplateCard = ({ 
	templateData, 
	onEditItem, 
	onDeleteItem,
	onUseTemplate,
}) => {
	const { dict } = useSelector((state) => state.app);
	const { categoriesDict } = useSelector((state) => state.data);

	const { id: templateId, rights: { canUseLetterTemplate } } = templateData;

	return (
		<div className={ styles['template-card'] }>
			<div className={ styles['template-card__header'] }>
				<div className={ styles['template-card__header--text'] }>
					{templateData.title}
				</div>
			</div>
			<div className={ styles['template-card__body'] }>
				<div className={ `${styles['template-card__body--one-line-info']}` }>
					<div className={ styles['template-card__body--name'] }>{dict.templates.card.department}: </div>
					<div className={ styles['template-card__body--department'] }>
						{templateData.department.name}
					</div>
				</div>
				<div className={ styles['template-card__body--one-line-info'] }>
					<div className={ styles['template-card__body--name'] }>{dict.templates.card.category}: </div>
					{categoriesDict[templateData.category.code]}
				</div>
				<div className={ styles['template-card--divider'] } />
				<div className={ styles['template-card__body--multi-line-info'] }>
					<div className={ styles['template-card__body--name'] }>{dict.templates.card.basedOn}: </div>
					<div className={ styles['template-card__body--letter'] }>
						<Link
							className='table__item--btn title-blue'
							to={ `/letter/${templateData.letter.id}` }
						>{templateData.letter.title}
						</Link>
					</div>
				</div>
				<div className={ styles['template-card__body--multi-line-info'] }>
					<div className={ styles['template-card__body--name'] }>{dict.templates.card.author}: </div>
					<div>{templateData.owner.forename} {templateData.owner.surname}</div>
					<div className={ styles['template-card__body--email'] }>{templateData.owner.email}</div>
				</div>
				<div className={ styles['template-card--divider'] } />
				<div className={ styles['template-card__body--one-line-info'] }>
					<div className={ styles['template-card__body--name'] }>{dict.templates.card.createdOn}: </div>
					{formatTimeDate(templateData.createdOn)}
				</div>
				<div className={ styles['template-card__body--one-line-info'] }>
					<div className={ styles['template-card__body--name'] }>{dict.templates.card.updatedOn}: </div>
					{formatTimeDate(templateData.modifiedOn)}
				</div>
				<div className={ styles['template-card__actions'] }>
					<div className={ styles['template-card__actions--action'] }>
						<Link
							style={ { width: "100%" } }
							className='button__white'
							disabled={ !canUseLetterTemplate }
							to={ `/template/${templateId}` }
						>{dict.templates.card.useTemplate}
						</Link>
					</div>

					{ (templateData.rights.canEdit || templateData.rights.canDelete) &&
						<div className={ styles['template-card__actions--action'] }>
							<LetterTemplatesItemMenu
								onEditItem={ onEditItem }
								onDeleteItem={ onDeleteItem }
								onUseTemplate={ onUseTemplate }
								templateData={ templateData }
							/>
						</div>
					}
				</div>
			</div>
		</div>
	);
};

export default memo(LetterTemplateCard);